"use strict";
exports.__esModule = true;
exports.createUrl = exports.createHeaders = exports.createBody = void 0;
var tslib_1 = require("tslib");
var cross_fetch_1 = require("cross-fetch");
var form_data_1 = (0, tslib_1.__importDefault)(require("form-data"));
var createUrl = function (url, params) {
    if (!Object.entries(params).length) {
        return url;
    }
    var queryParams = new URLSearchParams(params);
    var queryString = queryParams.toString();
    var newUrl = "".concat(url, "?").concat(queryString);
    return newUrl;
};
exports.createUrl = createUrl;
var createHeaders = function (_a) {
    var _b = _a.headers, headers = _b === void 0 ? new cross_fetch_1.Headers() : _b, _c = _a.type, type = _c === void 0 ? "json" : _c;
    var newHeaders = new cross_fetch_1.Headers(headers);
    switch (type) {
        case "json":
            newHeaders.set("content-type", "application/json");
            break;
        case "form":
            break;
    }
    return newHeaders;
};
exports.createHeaders = createHeaders;
var createBody = function (_a) {
    var body = _a.body, _b = _a.type, type = _b === void 0 ? "json" : _b;
    if (!body) {
        return null;
    }
    switch (type) {
        case "json": {
            var newBody = JSON.stringify(body);
            return newBody;
        }
        case "form": {
            var form_1 = new form_data_1["default"]();
            Object.entries(body).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                form_1.append(key, value);
            });
            // form-data types do not match actual FormData types
            return form_1;
        }
    }
};
exports.createBody = createBody;
//# sourceMappingURL=utils.js.map